import React from 'react';

function Badge({ children, variant = 'primary', style = {} }) {
  const variantStyles = {
    primary: {
      backgroundColor: '#4361ee',
      color: 'white'
    },
    secondary: {
      backgroundColor: '#4cc9f0',
      color: 'white'
    },
    success: {
      backgroundColor: '#4ade80',
      color: 'white'
    },
    warning: {
      backgroundColor: '#facc15',
      color: 'black'
    },
    danger: {
      backgroundColor: '#f87171',
      color: 'white'
    },
    info: {
      backgroundColor: '#94a3b8',
      color: 'white'
    }
  };

  return (
    <span style={{
      display: 'inline-block',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '500',
      ...variantStyles[variant],
      ...style
    }}>
      {children}
    </span>
  );
}

export default Badge;